import { useState, useRef } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest, RequestStatus } from './useRequest';
import { API_PATH } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
export function useCallRecords(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams ?? {};
    const [allRecords, setAllRecords] = useState([]);
    const [hasNextPage, setHasNextPage] = useState(false);
    const lastIdRef = useRef(undefined);
    // 用 ref 追踪加载中状态，避免快速触发时读到旧闭包值
    const isLoadingMoreRef = useRef(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [isFirstLoading, setIsFirstLoading] = useState(false);
    const { requestStatus, request } = useRequest(API_PATH.ASSIST_RECORD);
    const pageSize = options.pageSize || 20;
    const { userId } = ctx._runtimeInfo.commonParams;
    async function loadCallRecordsData() {
        setIsFirstLoading(true);
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const res = await request({
                ...feCommonParams,
                activityId: options.activityId,
                leaderId: feCommonParams.userId,
                pageSize
            });
            if (!Array.isArray(res?.records)) {
                throw new Error('获取打call记录数据失败');
            }
            setAllRecords(res.records);
            setHasNextPage(res.hasNextPage || false);
            lastIdRef.current = res.lastId;
            ctx._raptorReport.monitorReportBizSuccess?.({
                apiPath: API_PATH.ASSIST_RECORD
            });
        }
        catch (error) {
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.ASSIST_RECORD
            });
            ctx._raptorReport.monitorReportLog?.(error.message, error, {
                category: 'ajaxError',
                level: 'error'
            });
        }
        finally {
            setIsFirstLoading(false);
        }
    }
    async function loadMoreCallRecords() {
        if (!hasNextPage || isLoadingMoreRef.current || requestStatus === RequestStatus.LOADING) {
            return;
        }
        isLoadingMoreRef.current = true;
        setIsLoadingMore(true);
        try {
            const res = await request({
                activityId: options.activityId,
                leaderId: userId,
                pageSize,
                lastId: lastIdRef.current
            });
            if (!Array.isArray(res?.records)) {
                throw new Error('获取打call记录数据失败');
            }
            setAllRecords(prev => [...prev, ...res.records]);
            setHasNextPage(res.hasNextPage || false);
            lastIdRef.current = res.lastId;
            ctx._raptorReport.monitorReportBizSuccess?.({
                apiPath: API_PATH.ASSIST_RECORD
            });
        }
        catch (error) {
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.ASSIST_RECORD
            });
            ctx._raptorReport.monitorReportLog?.(error.message, error, {
                category: 'ajaxError',
                level: 'error'
            });
        }
        finally {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
    }
    return {
        loadCallRecordsData,
        loadMoreCallRecords,
        requestStatus,
        isFirstLoading,
        allRecords,
        hasNextPage,
        isLoadingMore
    };
}
